import styled from 'styled-components';

const LandscapePage = styled.div`
  display: none;
  padding: 2rem;
  page-break-after: always;

  @media print {
    display: block;
  }

  @page {
    size: landscape;
  }
`;

const PortraitPage = styled.div`
  display: none;
  padding: 2rem;
  page-break-after: always;

  @media print {
    display: block;
  }

  @page {
    size: portrait;
  }
`;

const PrintedTable = styled.table`
  border: 1px solid #000;
  border-collapse: collapse;
  width: 100%;

  td,
  th {
    border: 1px solid #000;
  }
`;

export { LandscapePage, PortraitPage, PrintedTable };
